/* eslint-disable camelcase */
import { KycProcess, PhotoType } from '../constants/kyc';
import api from './api';
import { numberSafeCamelToSnakeCase } from '../lib';
import { KycFieldsSnapshot } from '../models/Kyc/Fields';
import { DocInfoSnapshot } from '../models/Kyc/Processes/DocInfo';
import { getBackVersion } from '../config';

const getKyc = <T>(process: KycProcess): Promise<T> =>
    api.request({
        method: 'GET',
        url: `${getBackVersion()}/agent/kyc/${process}`,
    });

const updateKycFields = <T>(
    process: KycProcess,
    data: Partial<KycFieldsSnapshot>
): Promise<T> =>
    api.request({
        method: 'POST',
        url: `${getBackVersion()}/agent/kyc/${process}/field`,
        data: {
            fields: Object.entries(data).map(([k, v]) => ({
                field: numberSafeCamelToSnakeCase(k),
                value: v,
            })),
        },
    });

const updateKycAgentInfo = <T>(
    process: KycProcess,
    isMobile: boolean,
    userAgent: string
): Promise<T> =>
    api.request({
        method: 'POST',
        url: `${getBackVersion()}/agent/kyc/${process}/agent_info`,
        data: {
            is_mobile: isMobile,
            user_agent: userAgent,
        },
    });

const resubmitKyc = <T>(process: KycProcess): Promise<T> =>
    api.request({
        method: 'POST',
        url: `${getBackVersion()}/agent/kyc/${process}/resubmit`,
    });

const sendChangeDeviceNotification = (process: KycProcess): Promise<null> =>
    api.request({
        method: 'POST',
        url: `${getBackVersion()}/agent/kyc/${process}/notify_change_device`,
    });

const startKycProcess = <T>(process: KycProcess): Promise<T> =>
    api.request({
        method: 'POST',
        url: `${getBackVersion()}/agent/kyc/${process}/start`,
    });

const checkCreci = (
    process: KycProcess,
    creci: string,
    creciUf: string
): Promise<void> =>
    api.request({
        method: 'POST',
        url: `${getBackVersion()}/agent/kyc/${process}/creci_check`,
        data: {
            creci: creci,
            creci_uf: creciUf,
        },
    });

type DocumentUrl = {
    url: string;
};

const getDocumentUrl = (
    process: KycProcess,
    document: PhotoType
): Promise<DocumentUrl> =>
    api.request({
        method: 'GET',
        url: `${getBackVersion()}/agent/kyc/${process}/document_url/${document}`,
    });

const importKycData = <T>(
    process: KycProcess,
    source: KycProcess
): Promise<T> =>
    api.request({
        method: 'POST',
        url: `${getBackVersion()}/agent/kyc/${process}/import/${source}`,
    });

const getDocInfo = (process: KycProcess): Promise<DocInfoSnapshot | null> =>
    api.request({
        method: 'GET',
        url: `${getBackVersion()}/agent/kyc/${process}/doc_info`,
    });

export default {
    getKyc,
    checkCreci,
    updateKycFields,
    updateKycAgentInfo,
    resubmitKyc,
    sendChangeDeviceNotification,
    startKycProcess,
    getDocumentUrl,
    importKycData,
    getDocInfo,
};
